export const isVisibleByPrivilegeCode = (code, item) => {
  if (code === 'admin') {
    return true;
  }
  return item.privilege === code;
};
